import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import { createContext, useContext, useState } from "react";
import { api } from "../api/api";
import RegisterDriverContext from "./registerDriver";


interface UserContextData {
  user: any;
  setUser: any;
  auth(data: any): Promise<void>;
  changePassword(data: any): Promise<void>;
  recoveryPassword(data: any): Promise<void>;
}

const UserContext = createContext({} as UserContextData);

export function UserProvider({ children }) {
  const navigation = useNavigation();
  const [user, setUser] = useState<any>([]);

  async function auth(data: any) {
    try {
      await api
      .post("/auth/signin", data)
      .then(async (response: any) => {
        setUser(response.data);
        await AsyncStorage.setItem('@lmatransportes:accessToken', response.data.accessToken);
        await AsyncStorage.setItem('@lmatransportes:role', (response.data.role_id).toString());
        await AsyncStorage.setItem('@lmatransportes:role_name', response.data.role_name);
        await AsyncStorage.setItem('@lmatransportes:name', response.data.name);
        await AsyncStorage.setItem('@lmatransportes:email', response.data.email);
        await AsyncStorage.setItem('@lmatransportes:user_id', (response.data.user_id).toString());
        // first_access pode vir como boolean (FastAPI) ou 0/1 (compat) — trata ambos via truthy
        if(response.data.first_access){
          navigation.reset({
            index: 0,
            routes: [{ name: "ChangePassword" }],
          });
        } else {
          navigation.reset({
            index: 0,
            routes: [{ name: "Loading" }],
          });
        }
      })
    } catch (error) {
      console.log('auth => ', error);
      throw error;
    }
  }

  async function changePassword(data: any) {
    try {
      await api
      .put("/auth/change", data).then((response: any) => {
        console.log(response.data);
      })
    } catch (error) {
      console.log('changeFirstPassword => ', error);
      if(error?.response?.status === 401){
        navigation.reset({
          index: 0,
          routes: [{ name: "Login" }],
        });
      }
      throw error;
    }
  }

  async function recoveryPassword(data: any) {
    try {
      await api
      .post("/auth/recovery", data).then((response: any) => {
        console.log(response.data);
      })
    } catch (error) {
      console.log('recoveryPassword => ', error);
      if(error?.response?.status === 401){
        navigation.reset({
          index: 0,
          routes: [{ name: "Login" }],
        });
      }
      throw error;
    }
  }

  // async function updateProfile(data: any) {
  //   const accessToken = await AsyncStorage.getItem('@lmatransportes:accessToken');
  //   try {
  //     await api
  //     .post("/auth/signin", data, {
  //       headers: {'x-access-token' : accessToken}
  //     }).then(async (response: any) => {
  //       setUser(response.data);
  //       await AsyncStorage.setItem('@lmatransportes:accessToken', response.data.accessToken);
  //       await AsyncStorage.setItem('@lmatransportes:role', (response.data.role_id).toString());
  //       await AsyncStorage.setItem('@lmatransportes:role_name', response.data.role_name);
  //       await AsyncStorage.setItem('@lmatransportes:name', response.data.name);
  //       await AsyncStorage.setItem('@lmatransportes:email', response.data.email);
  //       if(response.data.first_access === 1){
  //         navigation.reset({
  //           index: 0,
  //           routes: [{ name: "ChangePassword" }],
  //         });
  //       }
  //       if(response.data.first_access === 0){
  //         navigation.reset({
  //           index: 0,
  //           routes: [{ name: "Loading" }],
  //         });
  //       }
  //     })
  //   } catch (error) {
  //     console.log('auth => ', error);
  //     throw error;
  //   }
  // }

  return (
    <UserContext.Provider value={{ user, setUser, auth, changePassword, recoveryPassword }}>
      {children}
    </UserContext.Provider>
  );
}

export default UserContext;
